export const shouldNativeShare = (): boolean => {
  if (typeof navigator === "undefined" || typeof navigator.share !== "function") return false;
  const coarse = window.matchMedia("(pointer: coarse)").matches;
  const mobileUa = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  return coarse || mobileUa;
};

const isAbort = (error: unknown): boolean =>
  Boolean(error && typeof error === "object" && "name" in error && error.name === "AbortError");

export const copyText = async (value: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // Fall through to the older copy path.
    }
  }
  const field = document.createElement("textarea");
  field.value = value;
  field.setAttribute("readonly", "");
  field.style.position = "fixed";
  field.style.left = "-9999px";
  document.body.append(field);
  field.select();
  const ok = document.execCommand("copy");
  field.remove();
  if (!ok) throw new Error("copy failed");
};

export const shareOrCopy = async (
  url: string,
  title: string,
  text: string,
): Promise<"shared" | "copied" | "cancelled"> => {
  if (shouldNativeShare()) {
    try {
      const data: ShareData = { title, text, url };
      if (typeof navigator.canShare !== "function" || navigator.canShare(data)) {
        await navigator.share(data);
        return "shared";
      }
    } catch (error) {
      if (isAbort(error)) return "cancelled";
    }
    try {
      await navigator.share({ title, text: `${text}\n${url}` });
      return "shared";
    } catch (error) {
      if (isAbort(error)) return "cancelled";
    }
  }
  await copyText(url);
  return "copied";
};

export const shareAppLink = async (): Promise<"shared" | "copied" | "cancelled"> =>
  shareOrCopy(`${window.location.origin}/`, "Reading Bee", "Reading Bee helps beginner readers learn to read.");
